<template>
  <div class="users-table table-component">
    <artisio-table
        :pagination="tableData.pagination"
        :sort="tableData.ordering"
        :busy="tableData.loading"
        :items="rows"
        :fields="tableData.tableFields"
        :enable-simple-search="false"
        @paramsChanged="paramsChanged"
        :extra-data="extraData">

      <template v-slot:search-form-placeholder>
        <search-collapse table-id="users-table">
          <user-search/>
        </search-collapse>
      </template>

      <template slot="cell(first_name)" slot-scope="{item: user}">
        {{ user.display_name }}
        <action-buttons :view="false"
                        @editClick="onEditClick(user)"
                        @deleteClick="onRemoveClick(user)"/>
      </template>

      <template slot="cell(email)" slot-scope="{item: user}">
        {{ user.email }}
      </template>

      <template slot="cell(branch_uuid)" slot-scope="{item: user}">
        {{ user.branches ? user.branches.map(b => b.name).join(', ') : '' }}
      </template>

      <template slot="cell(is_blocked)" slot-scope="{item: user}">
        <span v-html="$options.filters.asBadgeBoolean(user.is_blocked)"/>
      </template>

      <template slot="cell(last_login)" slot-scope="{item: user}">
        {{ user.last_login | toDateTime }}
      </template>

      <template slot="cell(device)" slot-scope="{item: user}">
        {{ user.device }}
      </template>


      <template slot="cell(address)" slot-scope="{item: user}">
        <div v-if="user.full_address"
             v-html="$options.filters.splitAddressForMultiline(user.full_address)">
        </div>
      </template>

      <template slot="cell(actions)" slot-scope="{item}">
        <b-tooltip :target="`log-out-all-devices-btn-${item.uuid}`" :title="$t('Log Out from All Devices')"/>
        <b-button :id="`log-out-all-devices-btn-${item.uuid}`"
                  variant="primary" size="sm" class="ml-2" @click="onLogOutAllDevicesClick(item.uuid)">
          <font-awesome-icon icon="sign-out-alt" class="icon"/>
        </b-button>
      </template>

    </artisio-table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "../../../core/components/ams-table/ArtisioTable";
  import ActionButtons from "../../../core/components/ams-table/ActionButtons";
  import SearchCollapse from "@/core/components/search-collapse/SearchCollapse.vue";
  import UserSearch from "@/modules/setup/user/UserSearch.vue";
  import {USER_TABLE_NAME} from "@/modules/constants";
  import UserService from "@/modules/setup/user/UserService";

  const {mapState, mapActions} = createNamespacedHelpers('setup/user');

  export default {
    name: "UserTable",
    components: {UserSearch, SearchCollapse, ActionButtons, ArtisioTable},
    props: {
      searchParams: {
        type: Array,
        default: null,
      }
    },
    computed: {
      ...mapState({
        rows: state => state.tableData.rows,
        tableData: state => state.tableData
      }),
      extraData() {
        return {
          tableName: `${USER_TABLE_NAME}`,
        }
      }
    },
    methods: {
      ...mapActions(['getTableData', 'showModal', 'removeUser']),
      paramsChanged(payload) {
        this.getTableData(payload);
      },
      onEditClick(item) {
        this.showModal(item)
      },
      async onRemoveClick(user) {
        this.$confirm(
          this.$i18n.t("Are you sure you want to delete following user?"),
          this.$i18n.t('User was successfully deleted'),
          this.removeUser,
          user
        );
      },
      async onLogOutAllDevicesClick(user_uuid){
        let success = await this.$confirm('Are you sure you want to log out user from all devices?');
        if (!success) {
          return
        }
        const response = await UserService.logOutAllDevices(user_uuid)
        if (response.success){
          this.$toast('success', this.$i18n.t('Logged Out User from all Devices'));
        } else {
          this.$toast('danger', this.$i18n.t('Error Occurred!'));
        }
      }
    },
    mounted() {
      this.getTableData(this.tableData);
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";
</style>

